import { GapUnits } from '@wix/fast-gallery-library';

export const FAST_GALLERY_MAPPERS_SELECTORS = {
  parentSelector: '.container',
  itemSelector: '.item',
};

export const defaultFastGalleryProps = {
  itemClickAction: 'ACTION',
  layout: 'Custom Grid',
  layout_horizontal_gap: 0,
  layout_horizontal_gap_unit: GapUnits.px,
  layout_vertical_gap: 0,
  layout_vertical_gap_unit: GapUnits.px,
  custom_grid_pattern: '[[1,1,3],[2,1]]',
  custom_grid_opposite_pattern: '300px 400px',
  custom_grid_flip: false,
  custom_grid_mode: 'vertical',
  slider_item_width: 300,
  masonry_density: 10,
  customCss: '',
  item_info_position: 'BELOW',
  item_image_fit: 'crop',
  enableTitle: true,
  item_elements_alignment: 'flex-start',
  downloadProtection: true,
};
